import { ParseKeys } from 'i18next';
import { z } from 'zod';

import { regexNoSpacesOrSpecialChars } from '../../../../../utils';

export type SubscriptionTKey = ParseKeys<['subscription']>;

const Spec: {
  [key: string]: {
    maxLength: number;
    minLength: number;
    minLengthMessage: SubscriptionTKey;
    requiredMessage: SubscriptionTKey;
  };
} = {
  cardNumber: {
    maxLength: 16,
    minLength: 13,
    minLengthMessage: 'subscription:payment.cardRegister.validationCardNumber',
    requiredMessage: 'subscription:payment.cardRegister.validationCardNumber',
  },
  expireDate: {
    maxLength: 4,
    minLength: 4,
    minLengthMessage:
      'subscription:payment.cardRegister.validationExpireDateMin',
    requiredMessage:
      'subscription:payment.cardRegister.validationExpireDateRequired',
  },
  birthDate: {
    maxLength: 6,
    minLength: 6,
    minLengthMessage: 'subscription:payment.cardRegister.validationBirthDate',
    requiredMessage: 'subscription:payment.cardRegister.validationBirthDate',
  },
  businessNumber: {
    maxLength: 10,
    minLength: 10,
    minLengthMessage:
      'subscription:payment.cardRegister.validationBusinessNumberRequired',
    requiredMessage:
      'subscription:payment.cardRegister.validationBusinessNumberRequired',
  },
  name: {
    maxLength: 8,
    minLength: 1,
    minLengthMessage:
      'subscription:payment.cardRegister.validationCardNameRequired',
    requiredMessage:
      'subscription:payment.cardRegister.validationCardNameRequired',
  },
};
export const PaymentCardSchema = z.object({
  cardNumber: z
    .string({
      required_error: Spec.cardNumber.requiredMessage,
    })
    .max(Spec.cardNumber.maxLength)
    .min(Spec.cardNumber.minLength, {
      message: Spec.cardNumber.requiredMessage,
    }),
  expireDate: z
    .string({
      required_error: Spec.expireDate.requiredMessage,
    })
    .max(Spec.expireDate.maxLength)
    .min(Spec.expireDate.minLength, {
      message: Spec.expireDate.minLengthMessage,
    }),
  birthDate: z
    .string({
      required_error: Spec.birthDate.requiredMessage,
    })
    .min(Spec.birthDate.minLength, {
      message: Spec.birthDate.requiredMessage,
    })
    .max(Spec.birthDate.maxLength),
  businessNumber: z
    .string({
      required_error: Spec.businessNumber.requiredMessage,
    })
    .min(Spec.businessNumber.minLength, {
      message: Spec.businessNumber.minLengthMessage,
    })
    .max(Spec.businessNumber.maxLength),
  name: z
    .string({
      required_error: Spec.name.requiredMessage,
    })
    .regex(
      regexNoSpacesOrSpecialChars,
      'payment.cardRegister.validationCardNickname',
    )
    .max(Spec.name.maxLength)
    .min(Spec.name.minLength, {
      message: Spec.name.requiredMessage,
    }),
  isBusiness: z.boolean().default(false), // 법인유무
});

export const InputCardNameSchema = PaymentCardSchema.pick({
  name: true,
});

export type RegisterPaymentSchemaType = z.infer<typeof PaymentCardSchema>;
export type InputCardNameSchemaType = z.infer<typeof InputCardNameSchema>;
export const RegisterPaymentSchemaSpec = Spec;
